module.exports = __webpack_public_path__ + "img/dc10.c3fa335c.png";